/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserManagementListGroupResponse } from "./UserManagementListGroupResponse";

export type UserManagementListGroupResponseApiRespoonse = {
  data?: UserManagementListGroupResponse;
  status?: UserManagementListGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace UserManagementListGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
